import {
  Alert,
  Button,
  DeleteIcon,
  LinkIcon,
  Menu,
  MoreIcon,
  Space,
} from "melco-ui";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import isEmpty from "lodash/isEmpty";
import { useConfirm } from "../../../hooks/useConfirm";
import { useShouldShowWarning } from "../../../hooks/items/useShouldShowWarning";
import {
  Drawer as DrawerType,
  SharedserviceMelcoModelsAlphabetCollection,
} from "melco-shared-logic";
import { useDeleteFontCollections } from "../../../hooks/libraries/fontCollections/useDeleteFontCollections";

type FontCollectionDetailMoreActionButtonProps = {
  fontCollection: SharedserviceMelcoModelsAlphabetCollection;
  referencesDrawer: DrawerType;
};

export const FontCollectionDetailMoreActionButton: React.FC<
  FontCollectionDetailMoreActionButtonProps
> = ({ fontCollection, referencesDrawer }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const deleteFontCollection = useDeleteFontCollections();
  const shouldShowWarning = useShouldShowWarning();

  const confirmDelete = useConfirm(
    async () => {
      //TODO: Handle case if fontCollection.id doesnt exist
      if (fontCollection.id) {
        const successfullyDeletedIds = await deleteFontCollection([
          fontCollection.id,
        ]);

        // redirect to list view in case the entity was deleted successfully
        if (!isEmpty(successfullyDeletedIds)) {
          navigate(`/libraries/font-collections/embroidery`);
        }
      }
    },
    {
      translationPrefix: "font_collections.actions.delete",
      translationOptions: {
        count: 1,
      },
      content: shouldShowWarning(fontCollection) && (
        <Space direction="vertical" size="small">
          {t("font_collections.actions.delete.confirmation.message", {
            count: 1,
          })}
          <Alert
            type="warning"
            withBackground
            description={t(
              "font_collections.actions.delete.confirmation.warning",
              {
                count: 1,
              }
            )}
            showIcon={false}
          />
        </Space>
      ),
    }
  );

  const MoreActions = (
    <Menu>
      <Menu.Item
        key="more-actions-references"
        onClick={() => {
          referencesDrawer.openDrawer();
        }}
      >
        <LinkIcon /> {t("font_collections.actions.references.button")}
      </Menu.Item>
      <Menu.Item
        key="more-actions-delete"
        danger
        onClick={() => {
          confirmDelete();
        }}
      >
        <DeleteIcon /> {t("font_collections.actions.delete.button")}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={MoreActions}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <Button
        key="font-collections-more-actions"
        icon={<MoreIcon />}
        data-cy-id="font-collections-more-actions"
      />
    </Dropdown>
  );
};
